"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[517],{

/***/ 8517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var src_inherits = __webpack_require__(6533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(1296);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var src_create_super = __webpack_require__(9178);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(8802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1250);
// EXTERNAL MODULE: ../../modules/ui-base/dist/es/contexts/index.js + 5 modules
var contexts = __webpack_require__(5726);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(7350);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(8594);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(5846);
// EXTERNAL MODULE: ../../node_modules/.pnpm/isomorphic-fetch@2.2.1/node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(9060);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(3515);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(2991);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(3936);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(8167);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(3208);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(8235);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(1989);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(7680);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-form-validator-core@0.6.5_react-dom@17.0.2_react@17.0.2/node_modules/react-form-validator-core/lib/index.js
var lib = __webpack_require__(8081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(9106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/FilledInput/FilledInput.js
var FilledInput = __webpack_require__(8933);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl_FormControl = __webpack_require__(3985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText_FormHelperText = __webpack_require__(1749);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(6196);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(8607);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(3611);
;// CONCATENATED MODULE: ./components/input-validator.tsx
















var inputVariantComponent = {
    standard: Input/* default */.Z,
    filled: FilledInput/* default */.Z,
    outlined: OutlinedInput/* default */.Z
};
var InputValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,src_inherits/* default */.Z)(InputValidator, ValidatorComponent);
    var _super = (0,src_create_super/* default */.Z)(InputValidator);
    function InputValidator() {
        (0,src_class_call_check/* default */.Z)(this, InputValidator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isValid: true
        };
        return _this;
    }
    var _proto = InputValidator.prototype;
    _proto.render = function render() {
        var _props = this.props, errorMessages = _props.errorMessages, validators = _props.validators, containerClass = _props.containerClass, requiredError = _props.requiredError, helperText = _props.helperText, label = _props.label, validatorListener = _props.validatorListener, onKeyPress = _props.onKeyPress, variant = _props.variant, rest = (0,src_object_without_properties/* default */.Z)(_props, [
            "errorMessages",
            "validators",
            "containerClass",
            "requiredError",
            "helperText",
            "label",
            "validatorListener",
            "onKeyPress",
            "variant"
        ]);
        var isValid = this.state.isValid;
        var InputVariantComponent = inputVariantComponent[variant || "standard"];
        var extraProps = {};
        if (variant === "outlined") {
            extraProps.labelWidth = 1;
        }
        var id = rest.id || rest.name || "".concat(Date.now(), "-").concat(Math.floor(Math.random() * 1000)).slice(10);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl_FormControl/* default */.Z, {
            fullWidth: true,
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                    htmlFor: id,
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputVariantComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    id: id
                }, rest, extraProps), {
                    error: !isValid
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText_FormHelperText/* default */.Z, {
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return InputValidator;
}(lib/* ValidatorComponent */.nE);
// tslint:disable:max-classes-per-file

var SelectValidator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ValidatorComponent) {
    "use strict";
    _inherits(SelectValidator, ValidatorComponent);
    var _super = _create_super(SelectValidator);
    function SelectValidator() {
        _class_call_check(this, SelectValidator);
        return _super.apply(this, arguments);
    }
    var _proto = SelectValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, rest = _object_without_properties(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass"
        ]);
        var isValid = this.state.isValid;
        return /*#__PURE__*/ _jsx(FormControl, {
            fullWidth: true,
            className: containerClass,
            children: /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, rest), {
                select: true,
                error: !isValid || error,
                helperText: !isValid && this.getErrorMessage() || helperText
            }))
        });
    };
    return SelectValidator;
}(ValidatorComponent)));
/**
 * Wrap form components in a validator component, that will display the error text, and set a
 * passed in `validClass`/`invalidClass`.
 */ var WrapValidator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ValidatorComponent) {
    "use strict";
    _inherits(WrapValidator, ValidatorComponent);
    var _super = _create_super(WrapValidator);
    function WrapValidator() {
        _class_call_check(this, WrapValidator);
        return _super.apply(this, arguments);
    }
    var _proto = WrapValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, children = _props.children, invalidClass = _props.invalidClass, validClass = _props.validClass, rest = _object_without_properties(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass",
            "children",
            "invalidClass",
            "validClass"
        ]);
        var isValid = this.state.isValid;
        var formContainerClass = "".concat(containerClass, " ").concat(isValid ? validClass ? validClass : "" : invalidClass ? invalidClass : "");
        return /*#__PURE__*/ _jsxs(FormControl, {
            fullWidth: true,
            className: formContainerClass,
            children: [
                children,
                /*#__PURE__*/ _jsx(FormHelperText, {
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return WrapValidator;
}(ValidatorComponent)));

// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+icons@4.11.3_@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(1185);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@material-ui+icons@4.11.3_@material-ui+core@4.12.4_@types+react@16.14.40_react-dom@17.0.2_react@17.0.2/node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(1924);
;// CONCATENATED MODULE: ./components/auth/default-login.tsx

















var styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        progress: {
            marginTop: theme.spacing(14)
        },
        loginCard: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("xs"), {
            height: "100%"
        }),
        cardPadding: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "370px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        cardPaddingLoading: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "370px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        textFields: {
            width: "100%"
        },
        heading: {
            textAlign: "center"
        },
        containerClass: {
            width: "100%",
            display: "block",
            textAlign: "center",
            height: "100%"
        },
        checkmark: {
            width: "74px",
            display: "block",
            margin: "0 auto",
            marginTop: theme.spacing(14)
        },
        checkmarkCircle: {
            strokeDasharray: 1000,
            strokeDashoffset: 0,
            animation: "$dash 0.9s ease-in-out"
        },
        checkmarkCheck: {
            strokeDasharray: 1000,
            strokeDashoffset: 1000,
            animation: "$dash-check 0.9s 0.35s ease-in-out forwards"
        },
        "@keyframes dash": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 0
            }
        },
        "@keyframes dash-check": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 100
            }
        }
    });
};
var DefaultLogin = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(DefaultLogin, _Component);
    var _super = (0,src_create_super/* default */.Z)(DefaultLogin);
    function DefaultLogin() {
        (0,src_class_call_check/* default */.Z)(this, DefaultLogin);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            showPassword: false
        };
        _this.handleMouseDownPassword = function(event) {
            event.preventDefault();
        };
        _this.handleClickShowPassword = function() {
            _this.setState({
                showPassword: !_this.state.showPassword
            });
        };
        return _this;
    }
    var _proto = DefaultLogin.prototype;
    _proto.onSubmit = function onSubmit(e) {
        var payload = {
            username: this.props.username ? this.props.username.toLowerCase() : this.props.username,
            password: this.props.password
        };
        this.props.onSubmit(e, payload);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, classes = _props.classes, onResetPassword = _props.onResetPassword;
        // FIXME: Using <br /> within a div is semantically incorrect - <br />
        // should only be used within a parapraph.
        var card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: classes.cardPadding,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* ValidatorForm */.WS, {
                ref: "form",
                method: "post",
                onSubmit: function(event) {
                    return _this.onSubmit(event);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.heading,
                        variant: "h5",
                        children: "Sign in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "username",
                        autoComplete: "username",
                        label: "Email",
                        validators: [
                            "required",
                            "isEmail"
                        ],
                        errorMessages: [
                            "this field is required",
                            "must be a valid email"
                        ],
                        value: this.props.username,
                        onChange: function(e) {
                            _this.props.onChangeUser(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "password",
                        autoComplete: "username",
                        label: "Password",
                        type: this.state.showPassword ? "text" : "password",
                        value: this.props.password,
                        validators: [
                            "required"
                        ],
                        errorMessages: [
                            "this field is required"
                        ],
                        onChange: function(e) {
                            _this.props.onChangePass(e.target.value);
                        },
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                tabIndex: -1,
                                onClick: this.handleClickShowPassword,
                                onMouseDown: this.handleMouseDownPassword,
                                children: this.state.showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                children: "Sign in"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                onClick: onResetPassword,
                                children: "Forgot password"
                            })
                        ]
                    })
                ]
            })
        });
        if (this.props.isSuccessful) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Successfully signed in!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: classes.checkmark,
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 130.2 130.2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    className: classes.checkmarkCircle,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeMiterlimit: "10",
                                    cx: "65.1",
                                    cy: "65.1",
                                    r: "60.1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    className: classes.checkmarkCheck,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: "10",
                                    points: "100.2,40.2 51.5,88.8 29.8,67.5 "
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (this.props.isLoading) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Signing you in..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            className: classes.progress,
                            size: 80,
                            color: "secondary"
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: classes.loginCard,
            children: card
        });
    };
    return DefaultLogin;
}(react.Component);
/* harmony default export */ var default_login = ((0,withStyles/* default */.Z)(styles)(DefaultLogin));

;// CONCATENATED MODULE: ./components/auth/forgot-password.tsx














var forgot_password_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        progress: {
            marginTop: theme.spacing(14)
        },
        loginCard: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("xs"), {
            height: "100%"
        }),
        cardPadding: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "300px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        cardPaddingLoading: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "370px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        textFields: {
            width: "100%"
        },
        heading: {
            textAlign: "center"
        },
        containerClass: {
            width: "100%",
            display: "block",
            textAlign: "center",
            height: "100%"
        },
        checkmark: {
            width: "74px",
            display: "block",
            margin: "0 auto",
            marginTop: theme.spacing(14)
        },
        checkmarkCircle: {
            strokeDasharray: 1000,
            strokeDashoffset: 0,
            animation: "dash 0.9s ease-in-out"
        },
        checkmarkCheck: {
            strokeDasharray: 1000,
            strokeDashoffset: 1000,
            animation: "dash-check 0.9s 0.35s ease-in-out forwards"
        },
        "@keyframes dash": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 0
            }
        },
        "@keyframes dash-check": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 100
            }
        }
    });
};
var ForgotPassword = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(ForgotPassword, _Component);
    var _super = (0,src_create_super/* default */.Z)(ForgotPassword);
    function ForgotPassword() {
        (0,src_class_call_check/* default */.Z)(this, ForgotPassword);
        return _super.apply(this, arguments);
    }
    var _proto = ForgotPassword.prototype;
    _proto.onSubmit = function onSubmit(e) {
        var payload = {
            username: this.props.username ? this.props.username.toLowerCase() : this.props.username,
            resetPassword: true
        };
        this.props.onChangePass("");
        this.props.onSubmit(e, payload);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, classes = _props.classes, onCancel = _props.onCancel;
        var card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: classes.cardPadding,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* ValidatorForm */.WS, {
                ref: "form",
                method: "post",
                onSubmit: function(event) {
                    return _this.onSubmit(event);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.heading,
                        variant: "h5",
                        children: "Reset password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "username",
                        label: "Email",
                        validators: [
                            "required",
                            "isEmail"
                        ],
                        errorMessages: [
                            "this field is required",
                            "must be a valid email"
                        ],
                        value: this.props.username,
                        onChange: function(e) {
                            _this.props.onChangeUser(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                children: "Reset password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                color: "primary",
                                onClick: onCancel,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        });
        if (this.props.isSuccessful) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Successfully signed in!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: classes.checkmark,
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 130.2 130.2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    className: classes.checkmarkCircle,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeMiterlimit: "10",
                                    cx: "65.1",
                                    cy: "65.1",
                                    r: "60.1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    className: classes.checkmarkCheck,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: "10",
                                    points: "100.2,40.2 51.5,88.8 29.8,67.5 "
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (this.props.isLoading) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Resetting your password..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "subtitle1",
                            children: "Please check your email for your confirmation code"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            className: classes.progress,
                            size: 80,
                            color: "secondary"
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: classes.loginCard,
            children: card
        });
    };
    return ForgotPassword;
}(react.Component);
/* harmony default export */ var forgot_password = ((0,withStyles/* default */.Z)(forgot_password_styles)(ForgotPassword));

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(8417);
;// CONCATENATED MODULE: ./components/auth/new-password.tsx


















var new_password_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        progress: {
            marginTop: theme.spacing(14)
        },
        loginCard: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("xs"), {
            height: "100%"
        }),
        cardPadding: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "580px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        cardPaddingLoading: (0,_define_property/* default */.Z)({
            height: "100%",
            paddingRight: "2em",
            paddingLeft: "2em",
            paddingTop: "2em"
        }, theme.breakpoints.up("sm"), {
            width: "500px !important",
            height: "370px !important",
            paddingRight: "4em !important",
            paddingLeft: "4em !important"
        }),
        textFields: {
            width: "100%"
        },
        heading: {
            textAlign: "center"
        },
        containerClass: {
            width: "100%",
            display: "block",
            textAlign: "center",
            height: "100%"
        },
        checkmark: {
            width: "74px",
            display: "block",
            margin: "0 auto",
            marginTop: theme.spacing(14)
        },
        checkmarkCircle: {
            strokeDasharray: 1000,
            strokeDashoffset: 0,
            animation: "dash 0.9s ease-in-out"
        },
        checkmarkCheck: {
            strokeDasharray: 1000,
            strokeDashoffset: 1000,
            animation: "dash-check 0.9s 0.35s ease-in-out forwards"
        },
        "@keyframes dash": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 0
            }
        },
        "@keyframes dash-check": {
            "0%": {
                strokeDashoffset: 1000
            },
            "100%": {
                strokeDashoffset: 100
            }
        }
    });
};
var NewPassword = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(NewPassword, _Component);
    var _super = (0,src_create_super/* default */.Z)(NewPassword);
    function NewPassword(props) {
        (0,src_class_call_check/* default */.Z)(this, NewPassword);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            newpassword: "",
            newpassword2: "",
            showOldPassword: false,
            showNewPassword: false,
            showNewPassword2: false,
            attributes: {}
        };
        _this.handleMouseDownPassword = function(event) {
            event.preventDefault();
        };
        _this.handleClickShowPassword = function(field) {
            _this.setState((0,_define_property/* default */.Z)({}, field, !_this.state[field]));
        };
        lib/* ValidatorForm.addValidationRule */.WS.addValidationRule("isPasswordMatch", function(value) {
            if (value !== _this.state.newpassword) {
                return false;
            }
            return true;
        });
        return _this;
    }
    var _proto = NewPassword.prototype;
    _proto.onSubmit = function onSubmit(e) {
        var _this = this;
        if (this.state.newpassword !== this.state.newpassword2) {
            return;
        }
        if (!this.props.challengeName) {
            return;
        }
        var payload = {
            username: this.props.username,
            password: this.state.newpassword,
            challengeName: this.props.challengeName,
            challengeCode: this.props.password,
            session: this.props.session
        };
        // We expect these two to be swapped in the initial user creation
        if (this.props.type === "NEW") {
            payload.challengeCode = this.state.newpassword;
            payload.password = this.props.password;
        }
        if (this.props.requiredAttributes && this.props.requiredAttributes.length) {
            this.props.requiredAttributes.map(function(att) {
                payload[att] = _this.state.attributes[att];
            });
        }
        this.props.onSubmit(e, payload);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, classes = _props.classes, passwordPolicy = _props.passwordPolicy;
        var validators = [
            "required"
        ];
        var validatorMessages = [
            "this field is required"
        ];
        if (passwordPolicy.MinimumLength) {
            validators.push("minStringLength:".concat(passwordPolicy.MinimumLength));
            validatorMessages.push("password must be atleast ".concat(passwordPolicy.MinimumLength, " characters long"));
        }
        if (passwordPolicy.RequireLowercase) {
            validators.push("matchRegexp:(?=.*[a-z])");
            validatorMessages.push("password must contain atleast one lower case character");
        }
        if (passwordPolicy.RequireUppercase) {
            validators.push("matchRegexp:(?=.*[A-Z])");
            validatorMessages.push("password must contain atleast one upper case character");
        }
        if (passwordPolicy.RequireNumbers) {
            validators.push("matchRegexp:(?=.*\\d)");
            validatorMessages.push("password must contain atleast one number character");
        }
        if (passwordPolicy.RequireSymbols) {
            validators.push("matchRegexp:(.*[\\^\\$\\*\\.\\[\\]\\{\\}\\(\\)\\?\\-\\+\\\"\\!\\@\\#\\%\\&\\/\\,\\>\\<\\'\\:\\;\\|\\_\\~\\=\\`].*)");
            validatorMessages.push("password must contain atleast one symbol character");
        }
        var card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            className: classes.cardPadding,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* ValidatorForm */.WS, {
                ref: "form",
                method: "post",
                onSubmit: function(event) {
                    return _this.onSubmit(event);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.heading,
                        variant: "h5",
                        children: this.props.type === "RESET" ? "Reset password" : "Change password"
                    }),
                    this.props.type === "RESET" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.heading,
                        children: "Your password has been reset, please check your email for a verification code"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "username",
                        label: "Email",
                        validators: [
                            "required",
                            "isEmail"
                        ],
                        errorMessages: [
                            "this field is required",
                            "must be a valid email"
                        ],
                        value: this.props.username,
                        onChange: function(e) {
                            _this.props.onChangeUser(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "password",
                        label: this.props.type === "NEW" ? "Temporary password" : "Verification code",
                        type: this.state.showOldPassword || this.props.type === "RESET" ? "text" : "password",
                        value: this.props.password,
                        validators: [
                            "required"
                        ],
                        errorMessages: [
                            "this field is required"
                        ],
                        onChange: function(e) {
                            _this.props.onChangePass(e.target.value);
                        },
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                tabIndex: -1,
                                onClick: function() {
                                    return _this.handleClickShowPassword("showOldPassword");
                                },
                                onMouseDown: this.handleMouseDownPassword,
                                children: this.state.showOldPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "newPassword",
                        autoComplete: "new-password",
                        label: "New password",
                        type: this.state.showNewPassword ? "text" : "password",
                        value: this.state.newpassword,
                        validators: validators,
                        errorMessages: validatorMessages,
                        onChange: function(e) {
                            return _this.setState({
                                newpassword: e.target.value
                            });
                        },
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                tabIndex: -1,
                                onClick: function() {
                                    return _this.handleClickShowPassword("showNewPassword");
                                },
                                onMouseDown: this.handleMouseDownPassword,
                                children: this.state.showNewPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputValidator, {
                        className: classes.textFields,
                        containerClass: classes.containerClass,
                        name: "newPassword2",
                        autoComplete: "new-password",
                        label: "Repeat new password",
                        type: this.state.showNewPassword2 ? "text" : "password",
                        value: this.state.newpassword2,
                        validators: (0,_to_consumable_array/* default */.Z)(validators).concat([
                            "isPasswordMatch"
                        ]),
                        errorMessages: (0,_to_consumable_array/* default */.Z)(validatorMessages).concat([
                            "passwords must match"
                        ]),
                        onChange: function(e) {
                            return _this.setState({
                                newpassword2: e.target.value
                            });
                        },
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                tabIndex: -1,
                                onClick: function() {
                                    return _this.handleClickShowPassword("showNewPassword2");
                                },
                                onMouseDown: this.handleMouseDownPassword,
                                children: this.state.showNewPassword2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        type: "submit",
                        children: "Submit"
                    })
                ]
            })
        });
        if (this.props.isSuccessful) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Successfully signed in!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: classes.checkmark,
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 130.2 130.2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    className: classes.checkmarkCircle,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeMiterlimit: "10",
                                    cx: "65.1",
                                    cy: "65.1",
                                    r: "60.1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    className: classes.checkmarkCheck,
                                    fill: "none",
                                    stroke: "#73AF55",
                                    strokeWidth: "9",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: "10",
                                    points: "100.2,40.2 51.5,88.8 29.8,67.5 "
                                })
                            ]
                        })
                    ]
                })
            });
        } else if (this.props.isLoading) {
            card = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                className: classes.cardPaddingLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.containerClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.heading,
                            variant: "h5",
                            children: "Signing you in..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            className: classes.progress,
                            size: 80,
                            color: "secondary"
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: classes.loginCard,
            children: card
        });
    };
    return NewPassword;
}(react.Component);
/* harmony default export */ var new_password = ((0,withStyles/* default */.Z)(new_password_styles)(NewPassword));

;// CONCATENATED MODULE: ./pages/login.tsx


















// import MultiFactor from 'components/auth/multi-factor';
var login_styles = function(theme) {
    return (0,createStyles/* default */.Z)({
        fillHeight: {
            height: "100%"
        },
        gridItem: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("xs"), {
            height: "100%",
            width: "100%"
        }),
        formControl: {
            margin: theme.spacing()
        }
    });
};
var Login = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(Login, _Component);
    var _super = (0,src_create_super/* default */.Z)(Login);
    function Login() {
        (0,src_class_call_check/* default */.Z)(this, Login);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            type: "login",
            username: "",
            password: "",
            requiredAttributes: [],
            challengeName: null,
            session: null,
            passwordPolicy: {},
            isLoading: false,
            isSuccessful: false,
            formError: false
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onSubmit = function(snackbar) {
            return function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(e, payload) {
                    var _props, query, ref, clientId, ref1, authorizationCode, encodedForm, response, info, _, loginResponse;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this1.props, query = _props.router.query;
                                e.preventDefault();
                                ref = (0,_sliced_to_array/* default */.Z)(Array.isArray(query.clientId) ? query.clientId : [
                                    query.clientId
                                ], 1), clientId = ref[0];
                                payload.clientId = clientId !== null && clientId !== void 0 ? clientId : "";
                                ref1 = (0,_sliced_to_array/* default */.Z)(Array.isArray(query.authorizationCode) ? query.authorizationCode : [
                                    query.authorizationCode
                                ], 1), authorizationCode = ref1[0];
                                payload.authorizationCode = authorizationCode !== null && authorizationCode !== void 0 ? authorizationCode : "";
                                _this1.setState({
                                    isLoading: true
                                });
                                encodedForm = Object.keys(payload).map(function(key) {
                                    return encodeURIComponent(key) + "=" + encodeURIComponent(payload[key]);
                                }).join("&");
                                return [
                                    4,
                                    fetch_npm_browserify_default()("".concat(window.location.origin).concat(window.location.pathname), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded"
                                        },
                                        body: encodedForm,
                                        credentials: "same-origin"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _ = response.status;
                                switch(_){
                                    case 200:
                                        return [
                                            3,
                                            2
                                        ];
                                    case 400:
                                        return [
                                            3,
                                            4
                                        ];
                                    case 401:
                                        return [
                                            3,
                                            4
                                        ];
                                    case 406:
                                        return [
                                            3,
                                            4
                                        ];
                                    case 403:
                                        return [
                                            3,
                                            6
                                        ];
                                    case 412:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 419:
                                        return [
                                            3,
                                            10
                                        ];
                                    case 424:
                                        return [
                                            3,
                                            12
                                        ];
                                }
                                return [
                                    3,
                                    13
                                ];
                            case 2:
                                _this1.setState({
                                    isLoading: false,
                                    isSuccessful: true
                                });
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                loginResponse = _state.sent();
                                setTimeout(function() {
                                    return window.location.assign("".concat(loginResponse.authCallback, "?authorizationCode=").concat(loginResponse.authorizationCode));
                                }, 1000);
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                return [
                                    4,
                                    response.json()
                                ];
                            case 5:
                                info = _state.sent();
                                if (!info.message) {
                                    info.message = "Something unexpected happened.";
                                }
                                snackbar.spawn(info.message, "error");
                                return [
                                    2,
                                    _this1.setState({
                                        isLoading: false,
                                        formError: true
                                    })
                                ];
                            case 6:
                                return [
                                    4,
                                    response.json()
                                ];
                            case 7:
                                info = _state.sent();
                                if (!info.message) {
                                    info.message = "Access to an external resource was forbidden!";
                                }
                                snackbar.spawn(info.message, "error");
                                return [
                                    2,
                                    _this1.setState({
                                        isLoading: false,
                                        formError: true
                                    })
                                ];
                            case 8:
                                return [
                                    4,
                                    response.json()
                                ];
                            case 9:
                                info = _state.sent();
                                if (!info.requiredAttributes) {
                                    info.requiredAttributes = [];
                                }
                                if (!info.passwordPolicy) {
                                    info.passwordPolicy = {};
                                }
                                return [
                                    2,
                                    _this1.setState({
                                        isLoading: false,
                                        type: info.type === "NEW" ? "tempPassword" : "resetPassword",
                                        formError: false,
                                        requiredAttributes: info.requiredAttributes,
                                        challengeName: info.challengeName,
                                        passwordPolicy: info.passwordPolicy,
                                        session: info.session
                                    })
                                ];
                            case 10:
                                return [
                                    4,
                                    response.json()
                                ];
                            case 11:
                                info = _state.sent();
                                if (!info.message) {
                                    info.message = "Authentication session has expired.";
                                }
                                snackbar.spawn("".concat(info.message, " Redirecting to ").concat(info.redirect, "..."), "error");
                                return [
                                    2,
                                    setTimeout(function() {
                                        return window.location.assign(info.redirect);
                                    }, 2500)
                                ];
                            case 12:
                                return [
                                    2,
                                    _this1.setState({
                                        isLoading: false,
                                        type: "mfaCode",
                                        formError: false
                                    })
                                ];
                            case 13:
                                console.error("Got ".concat(response.status, " response code"), response.body);
                                snackbar.spawn("Something unexpected happened, please try again - if the error persists, please contact support@blackbird.online", "error");
                                return [
                                    2,
                                    _this1.setState({
                                        isLoading: false,
                                        formError: true
                                    })
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e, payload) {
                    return _ref.apply(this, arguments);
                };
            }();
        };
        return _this;
    }
    var _proto = Login.prototype;
    _proto.render = function render() {
        var _this = this;
        var classes = this.props.classes;
        var form = function(snackbar) {
            switch(_this.state.type){
                case "tempPassword":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_password, {
                        onChangeUser: function(v) {
                            return _this.setState({
                                username: v
                            });
                        },
                        onChangePass: function(v) {
                            return _this.setState({
                                password: v
                            });
                        },
                        username: _this.state.username,
                        password: _this.state.password,
                        challengeName: _this.state.challengeName,
                        requiredAttributes: _this.state.requiredAttributes,
                        passwordPolicy: _this.state.passwordPolicy,
                        session: _this.state.session,
                        isLoading: _this.state.isLoading,
                        onSubmit: _this.onSubmit(snackbar),
                        isSuccessful: _this.state.isSuccessful,
                        type: "NEW"
                    });
                case "resetPassword":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_password, {
                        onChangeUser: function(v) {
                            return _this.setState({
                                username: v
                            });
                        },
                        onChangePass: function(v) {
                            return _this.setState({
                                password: v
                            });
                        },
                        username: _this.state.username,
                        password: _this.state.password,
                        challengeName: _this.state.challengeName,
                        passwordPolicy: _this.state.passwordPolicy,
                        isLoading: _this.state.isLoading,
                        onSubmit: _this.onSubmit(snackbar),
                        session: _this.state.session,
                        isSuccessful: _this.state.isSuccessful,
                        type: "RESET"
                    });
                case "mfaCode":
                /*form = <NewPassword
             onSubmit={this.onSubmit}
             />;*/ case "forgotPassword":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(forgot_password, {
                        onChangeUser: function(v) {
                            return _this.setState({
                                username: v
                            });
                        },
                        onChangePass: function(v) {
                            return _this.setState({
                                password: v
                            });
                        },
                        username: _this.state.username,
                        onSubmit: _this.onSubmit(snackbar),
                        isLoading: _this.state.isLoading,
                        isSuccessful: _this.state.isSuccessful,
                        onCancel: function() {
                            return _this.setState({
                                type: "login"
                            });
                        }
                    });
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(default_login, {
                        onChangeUser: function(v) {
                            return _this.setState({
                                username: v
                            });
                        },
                        onChangePass: function(v) {
                            return _this.setState({
                                password: v
                            });
                        },
                        username: _this.state.username,
                        password: _this.state.password,
                        onSubmit: _this.onSubmit(snackbar),
                        isLoading: _this.state.isLoading,
                        isSuccessful: _this.state.isSuccessful,
                        onResetPassword: function() {
                            return _this.setState({
                                type: "forgotPassword"
                            });
                        }
                    });
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts/* default.Snackbar.Consumer */.Z.Snackbar.Consumer, {
            children: function(snackbar) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    className: classes.fillHeight,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        alignItems: "center",
                        justifyContent: "center",
                        className: classes.fillHeight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            className: classes.gridItem,
                            children: form(snackbar)
                        })
                    })
                });
            }
        });
    };
    return Login;
}(react.Component);
var __N_SSG = true;
/* harmony default export */ var login = ((0,router.withRouter)((0,withStyles/* default */.Z)(login_styles)(Login)));


/***/ })

}]);